export default "__VITE_ASSET__BnO91ReK__"